export const SIZE_OPTIONS = {
  xs: '20px',
  sm: '28px',
  md: '40px'
};
export const getSpinnerSize = (size = 'sm') => {
  return SIZE_OPTIONS[size];
};
export const getIconColor = use => {
  switch (use) {
    case 'danger':
      return 'fill-alert-default';
    case 'primary':
    case 'secondary':
    case 'secondary-alt':
      return 'fill-primary-default';
    case 'on-dark':
    case 'secondary-ghost':
      return 'fill-inverse-default-alt';
    case 'primary-white':
    case 'tertiary':
    case 'tertiary-light':
    case 'tertiary-extra-light':
    case 'tertiary-transparent':
      return 'icon-tertiary-default';
    case 'success':
      return 'fill-positive-default';
    case 'link':
      return 'icon-interactive-default';
    case 'primary-on-fill':
    case 'tertiary-on-fill':
      return 'icon-core-on-fill-default';
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument:\n ${use}`);
      }
  }
};
export const getIconSize = size => {
  switch (size) {
    case 'xs':
    case 'extra-small':
      return '500';
    case 'md':
    case 'medium':
      return '800';
    case 'sm':
    case 'small':
    default:
      return '700';
  }
};